const canCreate = (to, from, next) => {
	const settings = JSON.parse(localStorage.getItem('shiseido-settings')) || {}
	next(settings.permissions.global.creerPOF === 1 || settings.permissions.zone.creerPOF === 1 ? true : { path: '/' })
}

const canRefurb = (to, from, next) => {
	const settings = JSON.parse(localStorage.getItem('shiseido-settings')) || {}
	next(settings.permissions.global.renoverPOF === 1 || settings.permissions.zone.renoverPOF === 1 ? true : { path: '/' })
}

export default [
	{
		path: '/',
		component: () => import('@/components/layouts/LayoutMain'),
		children: [
			{
				path: '',
				name: 'Dashboard',
				component: () => import('@/components/views/ViewDashboard'),
				meta: { auth: true }
			},
			{
				path: '/new',
				name: 'ViewCreate',
				component: () => import('@/components/views/project/ViewCreate'),
				meta: { auth: true },
				beforeEnter: canCreate
			},
			{
				path: '/project/:id?/:notificationToken?',
				name: 'ViewManage',
				component: () => import('@/components/views/project/ViewManage'),
				meta: { auth: true }
			},
			{
				path: '/archive/:id?',
				name: 'ViewArchive',
				component: () => import('@/components/views/project/ViewManage'),
				meta: { auth: true }
			},
			{
				path: '/refurbishment/:id?',
				name: 'ViewRefurbish',
				component: () => import('@/components/views/project/ViewRefurbish'),
				meta: { auto: true },
				beforeEnter: canRefurb
			},
			{
				path: '/notifications',
				name: 'Notifications',
				component: () => import('@/components/views/ViewNotifications')
			}
		]
	},
	{
		path: '/welcome',
		name: 'Welcome',
		component: () => import('@/components/views/ViewWelcome')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/components/views/ViewLogin')
	},
	{
		path: '*',
		name: '404',
		component: () => import('@/components/views/ViewLogin')
	}
]



// WEBPACK FOOTER //
// ./src/router/routes.js